import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { FeatureGate } from '@/components/ui/FeatureGate';
import { CallCriteriaStep } from '@/features/call-criteria/components/CallCriteriaStep';

interface CallCriteriaSearch {
  /** Ключ критерия, чью панель открыть после загрузки списка (#2520, Э2). */
  criterion?: string;
}

// Custom call criteria (#861, plan §4.1). Without the flag the step is hidden
// from the strip (`useVisibleSteps`); the gate here covers a typed or
// bookmarked URL.
export const Route = createFileRoute('/analysis-setup/call-criteria')({
  validateSearch: (search: Record<string, unknown>): CallCriteriaSearch => ({
    criterion:
      typeof search.criterion === 'string' && search.criterion !== ''
        ? search.criterion
        : undefined,
  }),
  component: CallCriteriaRoute,
});

// The profile screen links here with `?criterion=<key>` (#2520): the step opens
// that criterion's panel once the list is in, and closing it drops the
// parameter so a reload does not open it again.
function CallCriteriaRoute() {
  const { criterion } = Route.useSearch();
  const navigate = useNavigate();
  return (
    <FeatureGate flag="enableCallCriteria">
      <CallCriteriaStep
        criterionKey={criterion}
        onCriterionKeyHandled={() =>
          void navigate({
            to: '/analysis-setup/call-criteria',
            search: {},
            replace: true,
          })
        }
      />
    </FeatureGate>
  );
}
